import React, { FC, RefObject, useEffect, useImperativeHandle } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment/moment';

import { TypePicker } from './type-picker';
import { TepRelevance } from 'constants/tep';
import Form from 'core/react/general/form/Form';
import { actions } from 'core/redux/api/reports';
import { CompaniesPicker } from './companies-picker';
import { EntryPassesPicker } from './entry-passes-picker';
import { ITepHistoryParameters } from 'types/redux/reports';
import { tepHistoryReportSelector } from 'core/redux/selectors/reports';

interface ITepHistoryProps {
  customRef: RefObject<any>;
  disabled: boolean;
  timeRange: { since: Date; until: Date };
}

export const TepHistory: FC<ITepHistoryProps> = ({ disabled, customRef, timeRange }) => {
  const dispatch = useDispatch();
  const { parameters } = useSelector(tepHistoryReportSelector);

  const getFilters = (params: ITepHistoryParameters) => {
    const { companies, entryPasses, retrospective, type, timeRange } = params;

    const startOn = `filter=startOn:"${moment(timeRange.since).format('YYYY-MM-DD')}"`;
    const endOn = `filter=endOn:"${moment(timeRange.until).format('YYYY-MM-DD')}"`;

    let filter = `${startOn}&${endOn}`;

    if (companies) {
      const companyFilter = companies.map((company) => `filter=company.id:${company}`).join('&');

      filter = `${filter}&${companyFilter}`;
    }

    if (entryPasses) {
      const entryPassesFilter = entryPasses.map((entryPass) => `filter=entryPass.device.uri:"${entryPass}"`).join('&');

      filter = `${filter}&${entryPassesFilter}`;
    }

    if (type && type !== 'all') {
      filter = `${filter}&filter=entryPass.expired:${type === TepRelevance.Expired}`;
    }

    return filter;
  };

  useImperativeHandle(customRef, () => ({
    submit: (values: any) => {
      const { companies, entryPasses, type } = values;
      const { companies: storedCompanies, entryPasses: storedEntryPasses, type: storedType } = parameters || {};
      const params = {
        companies: companies || storedCompanies,
        entryPasses: entryPasses || storedEntryPasses,
        type: type || storedType,
        timeRange,
      };

      dispatch(actions.tepHistory.setParams({ parameters: params, filters: getFilters(params) }));
    },
  }));

  useEffect(() => {
    dispatch(actions.tepHistory.loadEntryPasses());
    dispatch(actions.tepHistory.loadCompanies());
  }, []);

  return (
    <Form.ControlGroup key={50} disabled={disabled}>
      <Form.Control controlType={EntryPassesPicker} controlName="entryPasses" />
      <Form.Control controlType={CompaniesPicker} controlName="companies" />
      <Form.Control controlType={TypePicker} controlName="type" />
      {/*<Form.Control*/}
      {/*  controlName="retrospective"*/}
      {/*  // eslint-disable-next-line @typescript-eslint/ban-ts-ignore*/}
      {/*  // @ts-ignore*/}
      {/*  controlType={Form.Control.Type.Checkbox}*/}
      {/*  label={f('report later items first')}*/}
      {/*  initialValue={parameters?.retrospective || false}*/}
      {/*  disabled={disabled}*/}
      {/*/>*/}
    </Form.ControlGroup>
  );
};
